// AUTO-GENERATED from environment.outborn.production.ts by scripts/select-env.cjs — DO NOT EDIT.
// Edit environment.development.ts (local) or environment.production.ts (prod) instead.
import { StudyDeploymentConfig } from "./study.config";

// OUTBORN PRODUCTION values (project "outborn"). Selected by
// `node scripts/select-env.cjs production --project=outborn` (or PROJECT=outborn).
// Resonance lives on the BARE domain https://outborn-transfer.fr.
export const ENV = {
  REACT_APP_BASE_URL: 'https://kastafioreapi.outborn-transfer.fr',
  // TODO: paste the VAPID public key from the server's .env
  // (created by make-env.sh — checklist step 4) BEFORE the first deploy.
  VAPID_PUBLIC_KEY: "BFtcG5fYGq1yj8O6SBTgPUp_G7j2CxIj5bL5uW7cPxme0l6JjU_e1WnIvlOG-_nSG1D5LQ5vv6rqySRYVq0EopQ",
  // Bug-report / contact emails sent from the app (ReportBugModal).
  SUPPORT_FROM_EMAIL: 'noreply@outborn-transfer.fr',
  SUPPORT_TO_EMAILS: ['hosseinjamshidi87@gmail.com'],
  // Brand name (i18n {{appName}} default) + default UI language (html/i18n).
  APP_NAME: 'Outborn Transfer',
  DEFAULT_LANG: 'fr',
  // Single-study deployment: study id/slug/is_gamified are known up front, so the app
  // skips the slug -> id welcome lookup and the is_gamified call at bootstrap.
  // The slug MUST match the study you create in Diapason (checklist step 6);
  // id is 1 on a fresh database.
  STUDY: {
    mode: 'single',
    id: 1,
    slug: 'outborn',
    is_gamified: false,
  } as StudyDeploymentConfig,
}
